module.exports = __webpack_public_path__ + "img/icon-bathroom.da2ccc30.svg";